import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, compactFromU8a, compactToU8a, isString, u8aConcat, u8aToU8a } from '@polkadot/util';
import { Raw } from "../codec/Raw.mjs";
/** @internal */

function decodeBitVecU8a(value) {
  if (!value || !value.length) {
    return new Uint8Array();
  } // handle all other Uint8Array inputs, these do have a length prefix which is the number of bits encoded


  var _compactFromU8a = compactFromU8a(value),
      _compactFromU8a2 = _slicedToArray(_compactFromU8a, 2),
      offset = _compactFromU8a2[0],
      length = _compactFromU8a2[1];

  var total = offset + Math.ceil(length.toNumber() / 8);
  assert(total <= value.length, "BitVec: required length less than remainder, expected at least ".concat(total, ", found ").concat(value.length));
  return value.subarray(offset, total);
}
/** @internal */


function decodeBitVec(value) {
  if (Array.isArray(value) || isString(value)) {
    return u8aToU8a(value);
  }

  return decodeBitVecU8a(value);
}
/**
 * @name BitVec
 * @description
 * A BitVec that represents an array of bits. The bits are however stored encoded. The difference between this
 * and a normal Bytes would be that the length prefix indicates the number of bits encoded, not the bytes
 */


export var BitVec =
/*#__PURE__*/
function (_Raw) {
  _inherits(BitVec, _Raw);

  function BitVec(registry, value) {
    _classCallCheck(this, BitVec);

    return _possibleConstructorReturn(this, _getPrototypeOf(BitVec).call(this, registry, decodeBitVec(value)));
  }
  /**
   * @description The length of the value when encoded as a Uint8Array
   */


  _createClass(BitVec, [{
    key: "toRawType",

    /**
     * @description Returns the base runtime type name for this instance
     */
    value: function toRawType() {
      return 'BitVec';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      var bitVec = _get(_getPrototypeOf(BitVec.prototype), "toU8a", this).call(this);

      return isBare ? bitVec : u8aConcat(compactToU8a(this.bitLength()), bitVec);
    }
  }, {
    key: "encodedLength",
    get: function get() {
      return this.length + compactToU8a(this.bitLength()).length;
    }
  }]);

  return BitVec;
}(Raw);